module.exports = __webpack_public_path__ + "exo-latin-800.006e7ec97fc14c6682a8.woff";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-800.woff
// module id = ../../../../typeface-exo/files/exo-latin-800.woff
// module chunks = styles